<template>
  <TopRightArrowIcon />
</template>
<script>
import TopRightArrowIcon from '@/assets/images/common/icons/topright-arrow.svg?inline';

export default {
  name: 'TopRightArrow',
  components: {
    TopRightArrowIcon,
  },
};
</script>
<style lang="stylus" scoped>
 svg path {
  stroke: currentColor;
 }
</style>
